import './HomePageCard.scss';

import Paragraph from 'components/TextComps/Paragraph';
import { Link } from 'react-router-dom';
import Subtitle from 'components/TextComps/Subtitle';

type HomePageCardProps = {
  title: string;
  description: string;
  imageSrc: string;
  route: string;
  icon: JSX.Element;
};

export const HomePageCard = ({ title, description, imageSrc, route, icon }: HomePageCardProps) => {
  return (
    <div className='home-page-card'>
      <Link to={route}>
        <div className='home-page-card-image'>
          <img src={imageSrc} alt={title} />
        </div>

        <div className='home-page-card-description'>
          <div className='home-page-card-title'>
            <div className='home-page-card-icon-wrapper'>{icon}</div>
            <Subtitle>
              <>{title}</>
            </Subtitle>
          </div>
          <Paragraph>
            <>{description}</>
          </Paragraph>
        </div>
      </Link>
    </div>
  );
};
